import { createSelector } from '@reduxjs/toolkit';
import selfSelector from './self';

const trackerReportSelector = createSelector(selfSelector, (trackerStats) => trackerStats.report);

export default trackerReportSelector;
